import vatHelper from "@/utils/vat-helper";

const ACCOUNT_SECTION = "customer";
const BILLING_ADDRESS_SECTION = "billing_address";
const SHIPPING_ADDRESS_SECTION = "shipping_address";
const PAYMENT_SECTION = "payment_method";
const SUBSCRIPTION_SECTION = "subscription";
const SECTIONS = [ACCOUNT_SECTION, BILLING_ADDRESS_SECTION, SHIPPING_ADDRESS_SECTION, PAYMENT_SECTION, SUBSCRIPTION_SECTION];

var isEqual = function(obj1, obj2) {
  return Object.keys(obj1).filter(k => obj2[k] != obj1[k]).length == 0;
}

var isEmpty = function(obj) {
  return !Object.keys(obj).length
}

export default class SectionsResolver {
  constructor() {
    this.steps = [];
    this.review_steps = [];
  }

  resolve(state, rootState, dispatch, getters) {
    SECTIONS.forEach(section => this[section](state, rootState, dispatch, getters));
  }

  createAndValidateForm(state, dispatch, getters, fname, values) {
    var config = state.checkout_new.sections[fname].fields
    var name = "tmp_" + fname;
    dispatch('create_form', {
      name: name,
      config: config,
      def_values: values
    });

    if([BILLING_ADDRESS_SECTION, SHIPPING_ADDRESS_SECTION].indexOf(fname) > -1 ? getters.is_form_complete_only_required(name) : getters.is_form_complete(name)) {
      this.review_steps.push(fname);
    }
    else {
      this.steps.push(fname);
    }
  }

  [ACCOUNT_SECTION] (state, rootState, dispatch, getters) {
    if(state.checkout_new.sections.customer.fields.length > 0) {
      if(getters.data_overridden_from_hp) {
        this.steps.push("customer");
      }
      else {
        this.createAndValidateForm(state, dispatch, getters, ACCOUNT_SECTION, rootState.customer.data);
      }
    }
  }

  [BILLING_ADDRESS_SECTION] (state, rootState, dispatch, getters) {
    if(state.checkout_new.sections.billing_address.fields.length > 0) {
      if(getters.billing_address_already_present) {
        if(!getters.can_edit_billing_address) {
          this.review_steps.push("billing_address");
        }
        else {
          this.createAndValidateForm(state, dispatch, getters, BILLING_ADDRESS_SECTION, rootState.customer.billing_address);
        }

        dispatch('enable_copy_to_billing', false);
        return;
      }


      var output = rootState.customer.billing_address && Object.keys(rootState.customer.billing_address).length > 0;

      // if customer is already present and billing address is passed from hosted page params
      // add it to the steps
      if(output && !getters.authenticated) {

        // if vat can be shown for that country code and vat number is not present, then get it
        if(vatHelper.showVat(rootState.customer.billing_address.country) && !rootState.customer.data.vat_number) {
          this.steps.push("billing_address");
        }
        else {
          this.createAndValidateForm(state, dispatch, getters, BILLING_ADDRESS_SECTION, rootState.customer.billing_address);
        }
      }
      else {
        this.steps.push("billing_address");
        return;
      }
    }
  }

  [SHIPPING_ADDRESS_SECTION] (state, rootState, dispatch, getters) {
    if(state.checkout_new.sections.shipping_address.fields.length > 0) {
      if(getters.transient_shipping_address) {
        if(!(!getters.authenticated && getters.ship_to_billing_enabled && isEqual(rootState.customer.billing_address, getters.transient_shipping_address))) {
          dispatch('enable_copy_to_billing', false);
          this.createAndValidateForm(state, dispatch, getters, SHIPPING_ADDRESS_SECTION, getters.transient_shipping_address);
          return;
        }
      }

      if(getters.shipping_address_list.length > 0) {
        dispatch('enable_copy_to_billing', false);
        this.review_steps.push(SHIPPING_ADDRESS_SECTION);
        return;
      }

      if(getters.ship_to_billing_enabled){
        return;
      }

      this.steps.push(SHIPPING_ADDRESS_SECTION);
    }
  }

  [PAYMENT_SECTION] (state, rootState, dispatch, getters) {
    if(getters.is_checkout_new && !getters.one_screen_checkout && !(rootState.customer.payment_method_list.length > 0) && this.doRecaptchaCheckout(state,getters)){
      dispatch("set_recaptcha_checkout",true);
      return;
    }
    dispatch("set_recaptcha_checkout",false);
    if(rootState.customer.payment_method_list.length > 0) {
      this.review_steps.push(PAYMENT_SECTION);
    }
    else {
      this.steps.push(PAYMENT_SECTION);
    }
  }

  [SUBSCRIPTION_SECTION] (state, rootState, dispatch, getters) {
    if(state.checkout_new.sections.subscription.fields.length > 0) {
      this.createAndValidateForm(state, dispatch, getters, SUBSCRIPTION_SECTION, rootState.order.subscription);
        return;
    }
  }


  doRecaptchaCheckout(state,getters) {
    if(getters.current_amount_due > 0) {
      return false;
    }
    //check if current_amount_due should be used
    return (this.checkForZeroDollarCheckout(state,getters) || this.hasTrialPeriod(state,getters) || this.freeCheckout(state,getters.estimate));
  }

  freeCheckout(state, estimate) {
    if(!state.ui_config["checkout.allow_without_payment.discounts"]) {
      return false;
    }
    return (this.anyDiscountApplied(estimate) && estimate.amount_due == 0);
  }

  checkForZeroDollarCheckout(state,getters) {
    if(!state.ui_config["checkout.allow_without_payment.free_plans"]) {
      return false;
    }
    let estimate = getters.estimate;
    return (!this.anyDiscountApplied(estimate) && getters.is_zero_dollar_plan && (isEmpty(estimate) || estimate.amount_due == 0));
  }

  hasTrialPeriod(state, getters) {
    return state.ui_config["checkout.allow_without_payment.trial_plans"] && getters.is_plan_having_trial && getters.hasTrialPeriod;
  }

  anyDiscountApplied(estimate) {
    //discount present  OR credits applied OR excess payments applied
    return ((estimate.line_item_discounts && estimate.line_item_discounts.length > 0) || (estimate.credits_applied > 0) || (estimate.amount_paid > 0));
  }
}


// WEBPACK FOOTER //
// ./src/utils/sections-resolver.js